// extracted by mini-css-extract-plugin
export default {"wrapper":"Overview_style_wrapper__C+WL9","rotate":"Overview_style_rotate__vn49J"};